var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMtllogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 54,
    viewBox: "0 0 93 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_8092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9368 41.3694V32.3456C28.9368 27.6975 25.1565 23.907 20.5128 23.907C18.1399 23.907 15.9982 24.8938 14.4684 26.4726C12.9386 24.8938 10.7901 23.907 8.42403 23.907C3.77348 23.907 0 27.6907 0 32.3456V41.383C0 42.2064 0.149579 42.921 0.367149 43.2408C0.509929 43.5403 1.36661 43.7717 2.40007 43.7717C3.43352 43.7717 4.25621 43.5471 4.42619 43.2544C4.65055 42.9414 4.80013 42.2132 4.80013 41.3626V32.3388C4.80013 30.338 6.42511 28.7047 8.42403 28.7047C10.423 28.7047 12.0547 30.3312 12.0547 32.3388V41.3626C12.0547 42.1928 12.2043 42.9074 12.4219 43.234C12.5715 43.5335 13.4281 43.7648 14.4684 43.7648C15.5086 43.7648 16.3381 43.5403 16.5081 43.2476C16.7325 42.9346 16.8889 42.2064 16.8889 41.3558V32.3319C16.8889 30.3312 18.5138 28.6979 20.5196 28.6979C22.5253 28.6979 24.1434 30.3244 24.1434 32.3319V41.3694C24.1434 42.1928 24.293 42.9074 24.5106 43.2272C24.6534 43.5267 25.5101 43.758 26.5435 43.758C27.577 43.758 28.4065 43.5335 28.5696 43.2408C28.794 42.9278 28.9436 42.1996 28.9436 41.349L28.9368 41.3694Z",
    fill: "#E6007E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2821 39.3142C56.9693 39.0964 56.2622 38.9467 55.4327 38.9399H53.5766C51.5777 38.9399 49.9459 37.3134 49.9459 35.3059V19.5448C49.9459 18.7146 49.7963 18 49.5787 17.6733C49.4359 17.3739 48.5793 17.1425 47.5458 17.1425C46.5124 17.1425 45.6897 17.3671 45.5197 17.6597C45.2953 17.9728 45.1457 18.7009 45.1457 19.5448V35.3059C45.1457 39.9607 48.926 43.7444 53.5766 43.7444H55.4327C56.2486 43.7444 56.9489 43.5879 57.2685 43.3769C57.5676 43.234 57.7988 42.3766 57.7988 41.3422C57.7988 40.3078 57.5744 39.4843 57.2821 39.3142Z",
    fill: "#E6007E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6635 39.3142C43.3576 39.0964 42.6437 38.9467 41.8074 38.9399H39.9513C37.9523 38.9399 36.3274 37.3134 36.3274 35.3059V29.2083H40.1416C40.9711 29.2083 41.685 29.0586 42.0114 28.8408C42.3105 28.6979 42.5417 27.8405 42.5417 26.806C42.5417 25.7716 42.3173 24.9482 42.025 24.7781C41.7122 24.5535 40.9847 24.4038 40.1348 24.4038H36.3206V19.5448C36.3206 18.7146 36.171 18 35.9534 17.6733C35.8038 17.3739 34.954 17.1425 33.9205 17.1425C32.887 17.1425 32.0644 17.3671 31.8944 17.6597C31.6768 17.9728 31.5204 18.7009 31.5204 19.5448V35.3059C31.5204 39.9607 35.3007 43.7444 39.9445 43.7444H41.8006C42.6165 43.7444 43.3168 43.5879 43.6363 43.3769C43.9355 43.234 44.1667 42.3766 44.1667 41.3422C44.1667 40.3078 43.9423 39.4843 43.6499 39.3142H43.6635Z",
    fill: "#E6007E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.129183 49.3452H0.94507L2.27089 51.5093L3.5967 49.3452H4.41259V53.9251H3.65109V50.6382L2.27768 52.7955H2.25049L0.890677 50.6518V53.9251H0.129183V49.3452Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52083 51.9788V49.3452H6.28233V51.9516C6.28233 52.8023 6.69707 53.2582 7.38378 53.2582C8.07048 53.2582 8.47842 52.8295 8.47842 51.9856V49.352H9.23992V51.9516C9.23992 53.3195 8.50562 54.0068 7.37018 54.0068C6.23474 54.0068 5.52083 53.3195 5.52083 51.9924V51.9788Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.538 49.3112H12.2451L14.1556 53.9251H13.3465L12.9046 52.8227H10.8513L10.4026 53.9251H9.62067L11.5312 49.3112H11.538ZM12.6326 52.1013L11.878 50.2707L11.1301 52.1013H12.6258H12.6326Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8287 49.3452H15.5358L17.8679 52.5096V49.3452H18.6226V53.9251H17.9835L15.5834 50.6654V53.9251H14.8287V49.3452Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4725 51.6454V51.6318C19.4725 50.3524 20.404 49.2635 21.7162 49.2635C22.4709 49.2635 22.94 49.4881 23.3888 49.8828L22.906 50.4885C22.5729 50.189 22.2397 49.9985 21.689 49.9985C20.8867 49.9985 20.2816 50.7403 20.2816 51.6114V51.625C20.2816 52.5641 20.8731 53.2582 21.757 53.2582C22.1649 53.2582 22.5389 53.1221 22.804 52.9112V52.0537H21.689V51.3528H23.5383V53.2786C23.11 53.6666 22.4981 53.9932 21.723 53.9932C20.3632 53.9932 19.4657 52.9724 19.4657 51.6386L19.4725 51.6454Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6926 50.0938H26.3124V49.3452H29.8411V50.0938H28.4609V53.9251H27.6926V50.0938Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6502 49.3452H31.4116V51.2507H33.4854V49.3452H34.2469V53.9251H33.4854V51.9924H31.4116V53.9251H30.6502V49.3452Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9121 49.3112H37.6192L39.5297 53.9251H38.7206L38.2787 52.8227H36.2254L35.7766 53.9251H34.9948L36.9053 49.3112H36.9121ZM38.0067 52.1013L37.252 50.2707L36.5041 52.1013H37.9999H38.0067Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3252 49.3452H41.0867V53.9251H40.3252V49.3452Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.459 49.3248H45.2205V53.1698H47.505V53.9047H44.4522V49.3248H44.459Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3481 49.3248H49.1096V53.9047H48.3481V49.3248Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2722 49.3248H53.5086V50.0597H51.0337V51.3119H53.223V52.0469H51.0337V53.9115H50.2722V49.3316V49.3248Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3516 49.3248H57.5744V50.0461H55.1131V51.2371H57.2956V51.9584H55.1131V53.1902H57.6016V53.9115H54.3448V49.3316L54.3516 49.3248Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7391 17.5168C92.7391 11.4533 91.6513 6.23365 90.0807 3.86541C89.0133 1.6741 82.7853 -0.00680542 75.2656 -0.00680542C67.7458 -0.00680542 61.7218 1.61966 60.5048 3.74972C58.8934 6.04991 57.7648 11.3512 57.7648 17.5304C57.7648 23.7096 58.8526 28.8136 60.4164 31.1751C61.4839 33.3664 67.7118 35.0405 75.2384 35.0405C82.7649 35.0405 88.7753 33.414 89.9991 31.2839C91.6105 28.9837 92.7391 23.6824 92.7391 17.51V17.5168Z",
    fill: "url(#paint0_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6778 11.6507V9.87448L67.2563 9.47297L66.8483 9.87448L66.4404 9.47297L66.0256 9.87448V10.3577L65.4613 10.1331L63.2448 10.8681V11.6507H67.6778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5785 17.3535L62.2522 17.0337L61.8374 17.442L61.6878 17.2923L62.1638 16.8159V12.9505L61.3547 12.1338L60.532 12.9505V17.3467L60.9467 17.7618H62.1706L62.5785 17.3535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8619 12.1202L66.0596 12.9505V16.2238L64.863 15.135V12.9505L64.0539 12.1202L62.8369 13.3588L63.2448 13.7671L63.6596 13.352L63.8092 13.5017L63.2516 14.0665V15.1554H63.0273L62.5445 16.0197L63.0273 16.8975H63.2516V17.3399L63.6732 17.7618H64.4415L64.863 17.3399V16.8839L66.2568 17.7618H67.2563L67.6778 17.3399V12.9505L66.8619 12.1202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4042 12.1066L68.1741 12.9505V13.6786L68.9696 13.9645L69.7991 13.6923L70.4246 13.2703L71.0366 13.6923V16.183L70.4246 16.5981L69.7991 16.183V16.0469L69.2076 15.448L69.3572 15.2983L69.7991 15.7474L70.2139 15.3323L68.99 14.121L68.1741 14.9308V16.8703L69.0784 17.7618H71.7573L72.6547 16.8703V12.9505L70.4042 12.1066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0975 12.1338L82.0986 13.2907V12.9505L81.2827 12.1406L80.0589 13.3656L80.4668 13.7671L80.8884 13.3452L81.038 13.4949L80.4736 14.0597V17.3467L80.8884 17.7618H81.6839L82.0986 17.3467V15.1758L83.2885 14.4749V17.3467L83.7032 17.7618H84.4851L84.9066 17.3467V12.9505L84.0975 12.1338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0336 12.1543L88.2246 12.9573V16.1081L87.6262 16.5981L87.0347 16.1217V15.6113L87.803 14.8423L86.4296 13.4677L86.5792 13.318L87.0415 13.7807L87.4563 13.3724L86.2256 12.1543L85.4165 12.9641V14.3592L85.8789 14.8151L85.4165 15.2711V16.8907L86.2936 17.7618H88.9657L89.8291 16.9043V12.9505L89.0336 12.1543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7682 12.1338L75.5443 13.3588L75.9591 13.7671L76.3738 13.352L76.5302 13.5017L75.9591 14.0733V16.1217L75.3607 16.5981L74.7692 16.1217V15.2302L73.9601 14.4204L73.1511 15.2302V16.8907L74.0349 17.7618H76.7138L77.5772 16.8975V12.9505L76.7682 12.1338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8005 17.0336L79.3858 17.4488L79.2226 17.2854L79.7121 16.7955V11.1471L78.5903 10.0106H77.8084L77.4073 10.4189L76.9993 10.0106H76.2174L75.3947 10.8272L76.2174 11.6439H78.094V17.3467L78.5087 17.7618H79.7053L80.1201 17.3399L79.8005 17.0336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8462 21.3618L70.3431 20.8582L69.8331 21.3686V21.9335L70.3431 22.4439L70.8462 21.9403V21.3618Z",
    fill: "url(#paint1_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8462 23.1924L70.3431 22.6888L69.8331 23.1992V23.7573L70.3431 24.2677L70.8462 23.7709V23.1924Z",
    fill: "url(#paint2_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9743 21.8722V24.118L73.2394 24.3834H73.7222L73.9873 24.118V21.3686L72.6071 20.8446L71.2133 21.3686V24.118L71.4785 24.3834H71.9612L72.2264 24.118V21.8722L72.6003 21.6136L72.9743 21.8722Z",
    fill: "url(#paint3_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8625 20.3818L65.3457 20.8922V23.2673L64.9718 23.5327L64.6114 23.2673V21.3686L64.1083 20.8582L63.34 21.6272L63.5984 21.879L63.8567 21.6136L63.9587 21.7157L63.5984 22.0832V23.8321L64.1491 24.3834H65.7945L66.3452 23.8321V20.8922L65.8625 20.3818Z",
    fill: "url(#paint4_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.956 22.2737L69.466 21.9539V21.355L68.0994 20.8582L66.7192 21.3686V22.8726V22.8862L67.2631 23.4306H68.4461V23.4715L68.7589 23.7845L68.6569 23.8866L68.4461 23.6688L68.1878 23.9274L68.6433 24.3834H69.2008L69.466 24.118V22.4166H67.7254V21.7974L68.956 22.2737Z",
    fill: "url(#paint5_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3325 22.7569H77.1897V21.3618L76.7002 20.8446L76.1834 21.3618V22.7705L75.4355 23.2401V21.3822L74.9324 20.8446L74.1641 21.6272L74.4157 21.879L74.6401 21.6681L74.7352 21.7633L74.4225 22.0832V24.186L74.6197 24.3834H75.4084L76.1834 23.873V24.118L76.4486 24.3834H76.9313L77.1897 24.118V23.8389H77.3325L77.6316 23.2945L77.3325 22.7569Z",
    fill: "url(#paint6_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3409 19.8238H73.3822L73.0559 20.1505L72.9539 20.0484L73.1783 19.8238V19.6333L72.7295 19.3202L72.2876 19.6401V20.2389L72.5935 20.552H74.3545L74.81 20.1913L74.3409 19.8238Z",
    fill: "url(#paint7_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7048 20.552V19.5448L80.1881 19.014L79.6714 19.5448V19.7422L79.2906 19.6061L77.89 20.062V20.552H80.7048Z",
    fill: "url(#paint8_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0856 20.552H83.88V20.0892L82.4862 19.6197L81.0856 20.0688V20.552Z",
    fill: "url(#paint9_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7116 21.3686L80.2085 20.8446L79.6986 21.3686V21.7293L79.209 22.2329L79.6986 22.7365V23.2605L79.2974 23.5259L78.8963 23.2605V21.3686L78.3999 20.8446L77.6248 21.6272L77.89 21.879L78.1076 21.6612L78.2096 21.7633L77.89 22.0832V23.8321L78.4407 24.3834H80.1609L80.7116 23.8321V22.5936L80.3377 22.2329L80.7116 21.8722V21.3686Z",
    fill: "url(#paint10_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5044 20.8582L85.6409 21.3686L84.7843 20.8446L84.2471 21.3686L84.2539 24.186L84.4511 24.3834H85.0426L85.9061 23.5259V22.9202L85.6341 22.6412L85.369 22.9202V23.0563L85.5322 23.2197L85.4302 23.3217L85.2602 23.1448H85.2534V21.8722L85.6409 22.1172L86.0149 21.8722V24.186L86.2121 24.3834H86.8308L87.0279 24.186V21.3686L86.5044 20.8582Z",
    fill: "url(#paint11_linear_607_8092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8732 21.3686L82.4794 20.8446L81.0856 21.3686V22.5459L81.5751 22.7297L82.0986 22.5459V21.8722L82.4794 21.6136L82.8669 21.8722V23.6892L82.7037 23.8525L82.6018 23.7573L82.8329 23.5191L82.4794 23.2877L82.0986 23.5123V24.1792L82.2958 24.3834H83.3293L83.88 23.8389L83.8732 21.3686Z",
    fill: "url(#paint12_linear_607_8092)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_607_8092",
    x1: 75.252,
    y1: 10.1739,
    x2: 75.252,
    y2: 35.0949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6007E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E5007B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E20174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DE0268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D80456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D1073F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#C70A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_607_8092",
    x1: 70.3431,
    y1: 20.9059,
    x2: 70.3431,
    y2: 24.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#008BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0484C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0978BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1266AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C4F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#29337A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_607_8092",
    x1: 0.000109882,
    y1: 20.9059,
    x2: 0.681218,
    y2: 24.3899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#008BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0484C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0978BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1266AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C4F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#29337A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_607_8092",
    x1: 72.6003,
    y1: 20.9059,
    x2: 72.6003,
    y2: 24.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#008BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0484C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0978BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1266AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C4F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#29337A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_607_8092",
    x1: 64.8426,
    y1: 20.9059,
    x2: 64.8426,
    y2: 24.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#008BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0484C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0978BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1266AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C4F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#29337A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_607_8092",
    x1: 68.0926,
    y1: 20.9059,
    x2: 68.0926,
    y2: 24.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#008BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0484C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0978BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1266AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C4F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#29337A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_607_8092",
    x1: 75.8979,
    y1: 20.9059,
    x2: 75.8979,
    y2: 24.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#008BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0484C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0978BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1266AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C4F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#29337A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_607_8092",
    x1: 73.5454,
    y1: 20.865,
    x2: 73.5454,
    y2: 24.3834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#008BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0484C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0978BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1266AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C4F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#29337A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_607_8092",
    x1: 79.2974,
    y1: 21.0896,
    x2: 79.2974,
    y2: 24.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6FB96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#68B369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5CA962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4A9B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#33894B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#17723B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00602E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_607_8092",
    x1: 82.4794,
    y1: 21.0896,
    x2: 82.4794,
    y2: 24.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6FB96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#68B369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5CA962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4A9B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#33894B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#17723B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00602E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_607_8092",
    x1: 79.1682,
    y1: 21.0896,
    x2: 79.1682,
    y2: 24.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6FB96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#68B369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5CA962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4A9B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#33894B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#17723B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00602E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_607_8092",
    x1: 85.6341,
    y1: 21.0896,
    x2: 85.6341,
    y2: 24.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6FB96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#68B369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5CA962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4A9B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#33894B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#17723B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00602E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_607_8092",
    x1: 82.4794,
    y1: 21.0896,
    x2: 82.4794,
    y2: 24.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6FB96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#68B369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5CA962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4A9B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#33894B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#17723B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00602E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_8092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.7391,
    height: 54,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtllogo);
export default __webpack_public_path__ + "static/media/MTLLOGO.a3976b9cf6c03dfd636624d992bb0b8d.svg";
export { ForwardRef as ReactComponent };